export default __webpack_public_path__ + "static/media/ptpa_seal_of_approval_award.6a179eba.png";